import React from 'react'

import { Mail } from 'components/Icons'
import { SegmentGroup } from 'components/Common'

export const Messages = props => {
  return (
    <SegmentGroup
      icon={<Mail width={30} height={30} />}
      showCount
      count={props.count}
      title='Messages'
      description='You have unread mail'
      linkTo='/notifications'
      linkText='View >'
    />
  )
}
